/**
 * Standard title formatter function is almost identical to the defaultTitleFormatter found in redux-logger
 * but removes placeholder characters previously used for styling, which is not being used in the logging
 * configuration
 *
 * @param action
 * @param time
 * @param took
 * @returns {string}
 */
export function titleFormatter (action, time, took) {
  var parts = ['action']
  parts.push(action.type)
  parts.push('@ ' + time)
  parts.push('(in ' + took.toFixed(2) + ' ms)')

  return parts.join(' ')
}
